<template>
  <!-- 头部 -->
  <header class="ban-top box-active">
    <div class="header-wrap">
          <div class="logo" style="cursor: pointer"
      @click="myclick">
      <img src="static/img/logo.png" alt="吉客云logo" />
    </div>
    <div class="ban-right">
      <!-- 首页主导航 -->
      <nav class="mav-wrap">
        <div>
          <a href="/"  class="mav-item" :class="{'navItem-bottom': ishome}" @mouseover="ishome=true"
            @mouseleave="ishome=false">首页</a>
        </div>
        <div>
          <a href="/pages/product.html"  class="mav-item" id="product-border" :class="{'navItem-bottom': isproduct}" @mouseover="isproduct=true"
            @mouseleave="isproduct=false">产品介绍</a>
        </div>

        <div @mouseover="ulShow(1)"
        @mouseleave="ulLeave()">
          <a href="/pages/solution.html"  class="mav-item" id="solution-border" :class="{'navItem-bottom': issolution}">解决方案</a>
          <ul v-if="solutionShow"         >
            <li><a href="/pages/onlineERP.html" >电商ERP解决方案</a></li>
            <li><a href="/pages/yunWMS.html" >三方云仓WMS解决方案</a></li>
            <li><a href="/pages/produceMRP.html" >产销一体化解决方案</a></li>
            <li><a href="/pages/distribution.html" >分销渠道数字化解决方案</a></li>
            <li><a href="/pages/finance.html" >业务财务一体化解决方案</a></li>
            <li><a href="/pages/oganization.html">企业组织数字化解决方案</a></li>
          </ul>
        </div>
                <div>
          <a href="/pages/successful-case.html"  class="mav-item" id="successful-border" :class="{'navItem-bottom': issuccessful}" @mouseover="issuccessful=true"
            @mouseleave="issuccessful=false">成功案例</a>
        </div>
        <div>
          <a  href="/official/platformList"   class="mav-item" :class="{'navItem-bottom': isplatform,'navItem-bottom-main':platform}" @mouseover="isplatform=true"
            @mouseleave="isplatform=false">平台对接</a>
        </div>
        <div class="newDynamic" @mouseover="ulShow(2)"
        @mouseleave="ulLeave()">
          <a href="/official/notice"   class="mav-item" :class="{'navItem-bottom': isnotice,'navItem-bottom-main':notice}">公司动态</a>
          <ul v-if="noticeshow"  >
            <li><a href="/official/newCenter" >新闻中心</a></li>
            <li><a href="/official/notice" >公司公告</a></li>
            <li><a href="/official/version" >版本升级</a></li>
            <li><a href="/official/platform" >平台对接</a></li>
            <!-- <li><a @click="addClass('notice3')" >需求反馈</a></li> -->
          </ul>
        </div>
        <div class="serviceNav" @mouseover="ulShow(4)" @mouseleave="ulLeave()">
          <a href="/pages/service.html" title="服务中心"  class="mav-item" :class="{'navItem-bottom': isservice,'navItem-bottom-main':service}" id="service-border">服务中心</a>
          <ul v-if="serviceshow">
            <li><a href="/pages/download.html">软件下载</a></li>
            <li><a href="/pages/service.html">服务体系</a></li>
            <li><a href="/pages/sell.html">产品报价</a></li>
            <!-- <li><a @click="addClass('calculator')">价格计算器</a></li> -->
              <li><a href="/pages/yunClass.html">云课堂</a></li>
            <li><a href="/pages/curriculum.html">培训课表</a></li>
            <li><a href="/pages/showhow.html">示范仓</a></li>
          </ul>
        </div>
        <div class="aboutUs" @mouseover="ulShow(3)" @mouseleave="ulLeave()">
          <a href="/pages/brief.html" title="关于我们"  class="mav-item" :class="{'navItem-bottom': isabout,'navItem-bottom-main':about}" >关于我们</a>
          <ul v-if="aboutshow">
            <li><a href="/pages/brief.html">公司简介</a></li>
            <li><a href="/pages/corporateStyle.html">员工风采</a></li>
            <li><a href="/pages/honour.html">荣誉资质</a></li>
              <li><a href="/pages/recruitment.html">人才招募</a></li>
            <li><a href="/pages/contact.html">联系我们</a></li>
          </ul>
        </div>
      </nav>
            <!-- 关注我们 -->
      <div class="nav-info">
        <span style="cursor: pointer" class="public-weixin" @mouseover="ulShow(5)" @mouseleave="ulLeave()">
          <img class="nav-icon" src="static/img/gongzhonghaoicon.png"   alt="吉客云-公众号图标" />
                 <div class="public-info" v-if="publicShow">
            <img src="static/img/gongzong.png"  alt="吉客云-公众号"/>
          </div>
        </span>
        <span style="cursor: pointer" @mouseover="ulShow(6)" @mouseleave="ulLeave()">
          <img class="nav-icon" src="static/img/toutiaoicon.png"  alt="吉客云-头条图标" />
                  <div class="toutiao-info" v-if="toutiaoShow">
            <img src="static/img/toutiao.png" alt="吉客云-头条" />
          </div>
        </span>
        <span style="cursor: pointer" @mouseover="ulShow(7)" @mouseleave="ulLeave()">
          <img class="nav-icon" src="static/img/douyinicon.png"   alt="吉客云-抖音图标" />
                  <div class="douyin-info" v-if="douyinShow">
            <img src="static/img/douyin.png" alt="吉客云-抖音"  />
          </div>
        </span>
        <span style="cursor: pointer" class="weibo" @mouseover="ulShow(8)" @mouseleave="ulLeave()">
          <img class="nav-icon" src="/static/img/imgs/7254@2x.png"   alt="吉客云-好礼" />
                  <div class="weibo-info" v-if="weiboShow">
              <p>好礼限时送!<br>
                仓库标识牌三选一</p>
              <img src="/static/img/imgs/7318@2x.png" alt="吉客云-好礼" />
              <a href="https://item.taobao.com/item.htm?id=641631495346" target="_blank"
                rel="noopener noreferrer external nofollow" style="margin-top: 11px;">
                付邮领取
              </a>
            </div>
        </span>
      </div>
    </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "nynav",
  data() {
    return {
      isScoll:false,
      notice:false,
      about:false,
      service:false,
      platform:false,
      isproduct:false,
      issuccessful:false,
      issolution:false,
      ishome:false,
      isplatform:false,
      isnotice:false,
      isabout:false,
      isservice:false,
      publicShow: false,
      weiboShow: false,
      toutiaoShow: false,
      douyinShow: false,
      aboutshow:false,
      serviceshow:false,
      noticeshow:false,
      solutionShow:false,
      navList: [
        { label: "首页", type: 0 },
        { label: "产品介绍", type: 1 },
        { label: "解决方案", type: 2 },
        { label: "平台对接", type: 3 },
        { label: "最新动态", type: 4 },
        { label: "服务中心", type: 5 },
        { label: "关于我们", type: 6 },
      ],
      timer: null, //bar定时器
      videoKanBuDong:
        "http://jkyun.oss-cn-hangzhou.aliyuncs.com/longterm/53/jkpan/533786265382584960/999300547751118848.mp4?Expires=4755925955&OSSAccessKeyId=LTAIh08vjrfC7HV0&Signature=JJLyftXAaKMGItcfVdf44ezNmBo%3D",
      videoSrc0:
        "https://jkyun.oss-cn-hangzhou.aliyuncs.com/longterm/53/jkpan/533786336601866880/667935585768243712.mp4?Expires=4716424133&OSSAccessKeyId=LTAIh08vjrfC7HV0&Signature=tM0wuWuDw091tL8Yk5Nmc09drgM%3D",
    };
  },
  // 在组件的computed中使用全局state
  computed: {
    aboutShow() {
      return this.$store.state.aboutShow;
    },
    noticeShow() {
      return this.$store.state.noticeShow;
    },
  },
  watch: {
    $route: {
      handler(newRouter) {
            this.platform = false;
            this.notice = false;
            this.service = false;
            this.about = false;
        switch (newRouter.name) {
          case "platform":
            this.platform = true;
            break;
          case "notice":
            this.notice = true;
            break;
          case "yunClass":
          case "calculator":
            this.service = true;
            break;
          // case "brief":
          // case "contact":
          // case "honour":
          // case "culture":
          // case "Development":
          //   this.about = true;
          //   break;
        }
      },
      immediate: true,
    },
  },
  methods: {
    ulShow(flag){
      if (this.timer) clearTimeout(this.timer);
      switch (flag) {
        case 1:
        this.issolution=true;
        this.isabout=false;
        this.isnotice=false;
        this.isservice=false;
          if (this.noticeshow || this.aboutshow||this.serviceshow||this.toutiaoShow || this.douyinShow|| this.publicShow||this.weiboShow) {
            this.noticeshow = false;
            this.aboutshow = false;
            this.serviceshow = false;
            this.toutiaoShow=false;
            this.douyinShow=false;
            this.publicShow=false;
            this.weiboShow=false;
            setTimeout(() => {
              this.solutionShow = true;
            }, 200);
          } else {
            this.solutionShow = true;
          }
          break;
        case 2:
        this.isnotice=true;
                this.isabout=false;
        this.isservice=false;
        this.issolution=false;
          if (this.solutionShow || this.aboutshow||this.serviceshow||this.toutiaoShow || this.douyinShow|| this.publicShow||this.weiboShow) {
            this.solutionShow = false;
            this.aboutshow = false;
            this.serviceshow = false;
                        this.toutiaoShow=false;
            this.douyinShow=false;
            this.publicShow=false;
            this.weiboShow=false;
            setTimeout(() => {
              this.noticeshow = true;
            }, 200);
          } else {
            this.noticeshow = true;
          }
          break;
        case 3:
        this.isabout=true;
                this.isservice=false;
        this.isnotice=false;
        this.issolution=false;
          if (this.noticeshow || this.solutionShow||this.serviceshow||this.toutiaoShow || this.douyinShow|| this.publicShow||this.weiboShow) {
            this.noticeshow = false;
            this.solutionShow = false;
            this.serviceshow = false;
                        this.toutiaoShow=false;
            this.douyinShow=false;
            this.publicShow=false;
            this.weiboShow=false;
            setTimeout(() => {
              this.aboutshow = true;
            }, 200);
          } else {
            this.aboutshow = true;
          }
          break;
        case 4:
        this.isservice=true;
        this.isabout=false;
        this.isnotice=false;
        this.issolution=false;
          if (this.noticeshow || this.solutionShow|| this.aboutshow||this.toutiaoShow || this.douyinShow|| this.publicShow||this.weiboShow) {
            this.noticeshow = false;
            this.solutionShow = false;
            this.aboutshow = false;
                        this.toutiaoShow=false;
            this.douyinShow=false;
            this.publicShow=false;
            this.weiboShow=false;
            setTimeout(() => {
              this.serviceshow = true;
            }, 200);
          } else {
            this.serviceshow = true;
          }
          break;
        case 5:
          if (this.toutiaoShow || this.douyinShow|| this.weiboShow||this.noticeshow || this.solutionShow|| this.aboutshow||this.serviceshow) {
            this.toutiaoShow = false;
            this.douyinShow = false;
            this.weiboShow = false;
                    this.solutionShow = false;
        this.noticeshow = false;
        this.aboutshow = false;
        this.serviceshow = false;
            setTimeout(() => {
              this.publicShow = true;
            }, 200);
          } else {
            this.publicShow = true;
          }
          break;
        case 6:
          if (this.publicShow || this.douyinShow|| this.weiboShow||this.noticeshow || this.solutionShow|| this.aboutshow||this.serviceshow) {
            this.publicShow = false;
            this.douyinShow = false;
            this.weiboShow = false;
                                this.solutionShow = false;
        this.noticeshow = false;
        this.aboutshow = false;
        this.serviceshow = false;
            setTimeout(() => {
              this.toutiaoShow = true;
            }, 200);
          } else {
            this.toutiaoShow = true;
          }
          break;
        case 7:
          if (this.weiboShow || this.publicShow|| this.weiboShow||this.noticeshow || this.solutionShow|| this.aboutshow||this.serviceshow) {
            this.toutiaoShow = false;
            this.publicShow = false;
            this.weiboShow = false;
                                this.solutionShow = false;
        this.noticeshow = false;
        this.aboutshow = false;
        this.serviceshow = false;
            setTimeout(() => {
              this.douyinShow = true;
            }, 200);
          } else {
            this.douyinShow = true;
          }
          break;
        case 8:
          if (this.toutiaoShow || this.douyinShow|| this.publicShow||this.noticeshow || this.solutionShow|| this.aboutshow||this.serviceshow) {
            this.toutiaoShow = false;
            this.douyinShow = false;
            this.publicShow = false;
                                this.solutionShow = false;
        this.noticeshow = false;
        this.aboutshow = false;
        this.serviceshow = false;
            setTimeout(() => {
              this.weiboShow = true;
            }, 200);
          } else {
            this.weiboShow = true;
          }
          break;
      }
    },
    ulLeave(){
      this.timer = setTimeout(() => {
        this.solutionShow = false;
        this.noticeshow = false;
        this.aboutshow = false;
        this.serviceshow = false;
        this.issolution=false;
        this.isnotice=false;
        this.isabout=false;
        this.isservice=false;
        this.toutiaoShow=false;
        this.douyinShow=false;
        this.publicShow=false;
        this.weiboShow=false;
      }, 100);
    },
    //导航默认跳转
    addClass(type) {
            const actions = new Map([
            ["platform",()=>{this.$router.replace("/platform");this.isplatform = true;}],
            ["statistics",()=>{this.$router.replace("/statistics");this.ishome = true;}],
            ["videos",()=>{this.$router.replace("/videos");this.ishome = true;}],
            ["custom",()=>{this.$router.replace("/custom");this.ishome = true;}],
            ["calculator",()=>{this.$router.replace("/calculator");this.isservice = true;}],
            ["yunClass",()=>{this.$router.replace("/yunClass");this.isservice = true;}],
            ["recruitment",()=>{this.$router.replace("/recruitment");this.ishome = true;}],
            ["notice1",()=>{this.$router.replace("/notice");
                            this.$store.commit("changeNotice", 1);this.isnotice = true;}],
            ["notice2",()=>{this.$router.replace("/notice");
                            this.$store.commit("changeNotice", 2);this.isnotice = true;}],
            ["notice3",()=>{this.$router.replace("/notice");
                            this.$store.commit("changeNotice", 3);this.isnotice = true;}],
            ["notice4",()=>{this.$router.replace("/notice");
                            this.$store.commit("changeNotice", 4);this.isnotice = true;}],
            ["notice5",()=>{this.$router.replace("/notice");
                            this.$store.commit("changeNotice", 5);this.isnotice = true;}],
          ]);
      let action = actions.get(type)
      action.call(this)
    },
    myclick() {
      // this.$emit("func", this.videoSrc0);
      window.location.href="/"
    },
    kanBuDongClick() {
      // 点击  看不懂，说人话
      this.$emit("func", this.videoKanBuDong);
    },
    //导航bar消失
    navBarHide() {
      this.$store.commit("navSlideHide");
    },
    //导航bar出现
    navBarShow(type) {
      this.$store.commit("navSlideShow", type);
    },

    handleScrollx(){
      if (window.pageYOffset>0) {
        this.isScoll = true;
      } else {
        this.isScoll = false;
      }
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScrollx);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScrollx);
  }
};
</script>
<style scoped>
html,
body {
  height: 100%;
  margin: 0;
  background-color: #fff;
  font-family: PingFang SC, Verdana, Helvetica Neue, Microsoft Yahei, Hiragino Sans GB, Microsoft Sans Serif, WenQuanYi Micro Hei, sans-serif;
}

html,
body {
  min-width: 1440px;
}

@media (max-width:1440px) {

  html,
  body {
    min-width: 1260px;
  }
}

ul,
li {
  list-style: none;
}

a{
  cursor: pointer;
  text-decoration: none;
}

*:focus {
  outline: none;
}
input{
  border: none;
}

.ban-top {
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  top: 0;
  z-index: 11;
  color: #4F4F4F;
  width: 1440px;
  background-color: #FFF;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
}

.header-wrap{
  width: 1440px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}

.logo {
  /* width: 140px;
  height: 70px; */
  z-index: 1;
  margin-top: 4px;
  text-align: center;
}

/* .logo img {
  width: 101px;
  height: auto;
} */

.ban-middle {
  margin-top: 30px;
  cursor: pointer;
}

.ban-txts {
  margin-top: 30px;
  font-size: 12px;
  opacity: 0.6;
}

.ban-right {
  flex: 1;
  display: flex;
  justify-content: space-between;
}

.nav-info {
  margin-top: 32px;
  font-size: 12px;
  text-align: right;
  position: relative;
  margin-left: 68px;
}

.nav-info span {
  float: left;
  padding-left: 18px;
  color: rgba(255, 255, 255, 0.6);
}

.nav-icon {
  width: 20px;
}

/*导航相关*/
.mav-wrap {
  position: relative;
  text-align: right;
  margin-top: 35px;
  font-size: 15px;
  font-family: Microsoft YaHei, Microsoft YaHei-Regular;
  font-weight: 400;
  line-height: 1px;
  letter-spacing: 1px;
}
.mav-wrap >div{
 /* display: inline-block; */
 height: 50px;
 position: relative;
 float: left;
}
.mav-wrap ul {
  box-sizing:border-box;
  /* display: none;  */
  text-align: left;
  position: absolute;
  left: -27px;
  width: 217px;
  background: #fff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.16);
  padding: 7px 0px 12px 26px;
  font-size: 14px;
  font-family: Microsoft YaHei, Microsoft YaHei-Regular;
  font-weight: 400;
  text-align: left;
  /* color: #fff; */
  line-height: 32px;
  letter-spacing: 1px;
  top: 50px;
  margin-top: 0px!important;
}
.mav-wrap ul li a{
  cursor: pointer;
  color: #4F4F4F;
  text-decoration: none;
}
.mav-wrap ul li:hover a{
  color:#004097;
}
.newDynamic ul{
  width: 113px;
  left: 24px;
}
.aboutUs ul {
  width: 113px;
  left: 24px;
}

.serviceNav ul {
  width: 126px;
  left: 24px;
}

.mav-item {
  display: inline-block;
  padding-top: 8px;
  padding-bottom: 15px;
  margin-left: 49px;
  cursor: pointer;
  text-decoration: none;
  color:#4F4F4F;
  font-weight: bold;
  border-bottom: 3px solid transparent;
}

.mav-item :last-child {
  padding-right: 0;
}
.box-active{
  position: fixed;
  top: 0;
}
.ban-top {
  width: 100%;
  -moz-transition:background-color 1s;
  -moz-transition-timing-function:ease-in-out;
  -webkit-transition:background-color 1s;
  -webkit-transition-timing-function:ease-in-out;
  -o-transition:background-color 1s;
  -o-transition-timing-function:ease-in-out;

}
.bg-top {
  background:#4B82DB;
  opacity: 0.95;

}
.ban-right {
  flex: none;
}

.ban-middle {
  margin-top: 35px;
}
.ban-txts {
  margin-top: 40px;
}
.navItem-bottom {
  border-bottom: 3px solid #004097;
  color:  #004097;
}
.navItem-bottom-main {
  border-bottom: 3px solid#004097;
  color:  #004097;
}
/* 导航相关结束*/

.d3 {
  width: 0;
  height: 0;
  display: inline-block;
  border-width: 6px;
  border-style: solid;
  border-color: transparent transparent transparent #fff;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to
/* .fade-leave-active below version 2.1.8 */

  {
  opacity: 0;
}

.public-info {
  width: 180px;
  height: 198px;
  position: absolute;
  right: -22px;
  top: 36px;
  z-index: 1;
  /* display: none; */
}

.weibo-info {
  position: absolute;
  right: -30px;
  top: 52px;
  z-index: 1;
  width: 201px;
  height: 316px;
  background: #FFFFFF;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  text-align: center;
}
.weibo-info p {
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #F2461D;
  margin: 10px;
}

.weibo-info img {
  width: 147px;
  height: 185px;
}

.weibo-info a {
  color: #fff;
  background-color: #F2461D;
  display: inline-block;
  width: 141px;
  height: 36px;
  border-radius: 36px;
  line-height: 34px;
  cursor: pointer;
  animation-delay: 0.4s;
  -webkit-animation-delay: 0.4s;
  font-weight: 500;
  font-size: 16px;
}
.toutiao-info {
  width: 180px;
  height: 198px;
  position: absolute;
  right: -22px;
  top: 36px;
  z-index: 1;
  /* display: none; */
}

.douyin-info {
  width: 180px;
  height: 198px;
  position: absolute;
  right: -22px;
  top: 36px;
  z-index: 1;
  /* display: none; */
}

.video-win {
  margin-top: 500px;
}


@media (max-width: 1440px) {
  .header-wrap{
    width: 1200px;
  }
  .mav-item {
    margin-left: 40px;}
    .nav-info {
      margin-left: 40px;
  }
  .mav-wrap ul {
    left: -35px;
  }

  .newDynamic ul{
    left: 13px;
  }
  .aboutUs ul {
    left: 13px;
  }

  .serviceNav ul {
    left: 13px
  }
}
@media (max-width: 900px) {
  .header-wrap{
    width: 900px;
  }
  .mav-item {
    margin-left: 15px;}
    .nav-info {
      margin-left: 26px;
  }
  .mav-wrap ul {
    left: -60px;
  }

  .newDynamic ul{
    left: -10px;
  }
  .aboutUs ul {
    left: -10px;
  }

  .serviceNav ul {
    left: -10px
  }
}


    /* QQ悬浮样式 */

    .sideTip {
      z-index: 9999;
      position: fixed;
      right: 0px;
      top: 300px;
  }

  .sideTip>li>a {
      width: 50px;
      height: 50px;
      background: rgba(68, 68, 68, 0.5);
      display: block;
      text-align: center;
      transition: all 0.3s;
      margin-bottom: 1px;
      /*no */
      -webkit-transition: all 0.3s;
      cursor: pointer;
  }

  .sideTip>li>a>img {
      width: 50px;
      height: 50px;
      opacity: 1;
      transition: all 0.3s;
      -webkit-transition: all 0.3s;
  }

  .sideTip>li:hover a {
      background: rgba(68, 68, 68, 0.8);
  }

  .pos {
      position: relative;
  }

  .tel {
      position: absolute;
      text-align: center;
      top: 0px;
      right: 50px;
      width: 250px;
      height: 50px;
      line-height: 50px;
      background: rgba(68, 68, 68, 0.8);
      color: #fff;
      font-size: 14px;
      display: none;
      animation: bounceInLeft 1s cubic-bezier(0.215, 0.610, 0.355, 1.000)
  }

  /**右侧qq,tel动画 */

  @keyframes bounceInLeft {
      0% {
          transform: translate3d(500px, 0, 0);
      }

      60% {
          /*  opacity: 1;*/
          transform: translate3d(0px, 0, 0);
      }

      75% {
          transform: translate3d(0px, 0, 0);
      }

      90% {
          transform: translate3d(0px, 0, 0);
      }

      100% {
          transform: translate3d(0px, 0, 0);
      }
  }

.headerCon {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: #000;
  z-index: 12;
}

.name-video {
  display: none;
}

.video-why {
  display: none;
}

.video-close {
  position: absolute;
  right: 14px;
  top: 14px;
  width: 40px;
  height: 34px;
}

.video-close::before,
.video-close::after {
  position: absolute;
  content: " ";
  background-color: #999;
  left: 20px;
  width: 2px;
  height: 34px;
}

.video-close::before {
  transform: rotate(45deg);
}

.video-close::after {
  transform: rotate(-45deg);
}

.video-close:hover:before,
.video-close:hover:after {
  background-color: #5485e8;
}

.video-wraps {
  width: 70%;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

#understand,
#jackunWhy {
  width: 100%;
  height: 100%;
  max-height: 800px;
}


.displayBlock {
  display: block;
}

.displayNone {
  display: none;
}


</style>



// WEBPACK FOOTER //
// src/components/nav-wrap.vue